import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box } from '@mui/material';
import nissanLogo from 'assets/nissan_logo.png';

// ブランドロゴ（NISSAN ワードマーク）。クリックでルート（/）へ戻る。
// 元画像は黒文字・透明背景のため、濃色 AppBar 上で視認できるよう白へ反転して表示する。
export const BrandLogo: React.FC = () => (
    <Box
        component={RouterLink}
        to="/"
        aria-label="ホームへ戻る"
        title="ホームへ戻る"
        sx={{ display: 'inline-flex', alignItems: 'center', mr: 1, flexShrink: 0 }}
    >
        <Box
            component="img"
            src={nissanLogo}
            alt="Nissan"
            sx={{ height: 24, display: 'block', filter: 'brightness(0) invert(1)' }}
        />
    </Box>
);
